export default __webpack_public_path__ + "static/Cerios-logo-full.6f49ed22.svg";